import React, { useState, useEffect } from "react";
import AuthRouter from "./authRouter";
import AdminRouter from "./adminRouter";
import { Cookies } from "react-cookie";
import { useNavigate, useLocation } from "react-router-dom";
import CoupleRouter from "./coupleRouter";
import AuthApi from "../api/authApi";

const IndexRouter = () => {
  const cookies = new Cookies();
  const [userRole, setUserRole] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {}, [userRole]);

  const checkFunciton = () => {
    if (cookies.get("LoveStrongUser")) {
      let data = cookies.get("LoveStrongUser");
      let token = cookies.get("LoveStrongToken");
      if (data.userRole && token) {
        return data.userRole;
      } else {
        return "";
      }
    } else {
      return false;
    }
  };

  const updateuser = (data) => {
    setUserRole(data); // change role of user Admin or User
  };

  const logoutUser = async () => {
    try {
      const authApi = new AuthApi();
      await authApi.Logout();
    } catch {
      /* still clear the session */
    }
    setUserRole("");
    cookies.remove("LoveStrongToken", { path: "/" });
    cookies.remove("LoveStrongUser", { path: "/" });
    navigate("/");
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const isLoggedIn = cookies.get("LoveStrongUser");
    if (
      !isLoggedIn &&
      (currentPath.startsWith("/retreat-registrations") ||
        currentPath === "/retreat-registrations")
    ) {
      const redirectUrl = encodeURIComponent(currentPath);
      navigate(`/login?redirect=${redirectUrl}`);
    }
  }, [location.pathname]);

  return (
    <>
      {checkFunciton() === "ADMIN" || checkFunciton() === "SUBADMIN" ? (
        <AdminRouter logoutUser={logoutUser} />
      ) : checkFunciton() === "COUPLE" ? (
        <CoupleRouter logoutUser={logoutUser} />
      ) : (
        <AuthRouter updatedUser={updateuser} />
      )}
    </>
  );
};

export default IndexRouter;
